import React from "react"
import RichText from "../../../shared/components/atoms/rich-text/rich-text"
import useHomeLinkMode from "../../../shared/hooks/useHomeLinkMode"
import "./card-specialist.scss"

const cardSpecialist = props => {
    const { talksInfo, isMobile, isCompleted = false, isSecondStyle, colorPrincipal = '' } = props

    const { homeLink } = useHomeLinkMode()
    return (
        <>
            {talksInfo.map((el, index) => (
                <div className={isSecondStyle ? "a-card-specialist--secondary" : "a-card-specialist"} key={index}>
                    <div className="a-card-specialist__img">
                        <img
                            src={el.imagenConferencistaLeccion.file.url}
                            alt={el.title}
                        />
                        {el.banderaConferencista &&
                            <div className="a-card-specialist__img__flag">
                                <img src={el.banderaConferencista?.file?.url} alt={el.banderaConferencista?.title} />
                            </div>
                        }
                    </div>
                    <div className="a-card-specialist__description">
                        <div 
                            style={{ backgroundColor: colorPrincipal }}
                            className="a-card-specialist__description-name"
                        >
                            <p>{`${el.nombreConferencistaLeccionista} ${isMobile ? "/ " + el.tituloDelConferencistaLeccion : ""}`}</p>
                        </div>
                        <div 
                            style={{ backgroundColor: colorPrincipal }}
                            className="a-card-specialist__description-speciality"
                        >
                            <p>{el.tituloDelConferencistaLeccion}</p>
                        </div>
                        {el.banderaConferencista &&
                            <div className="a-card-specialist__description-flag">
                                <img src={el.banderaConferencista?.file?.url} alt={el.banderaConferencista?.title} />
                                <RichText jsonInfo={el.nombreConferenciaLeccion?.json} /> 
                            </div>
                        }
                        <div className="a-card-specialist__description-title">
                            <div className="a-card-specialist__description-hour">
                                <RichText jsonInfo={el.horasConferencia?.json} />
                            </div>
                        </div>
                        {isCompleted &&
                            <a
                                href={homeLink + "academia-tena/" + props.webinarInfo?.slug + el.slug}
                                className="f-button f-button--primary f-button--rounded a-card-specialist__description-button"
                            >
                                VER AHORA
                            </a>
                        }
                    </div>
                </div>
            ))}
        </>
    )
}

export default cardSpecialist
